import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { concat, merge, of, from, Subscription, Subject } from 'rxjs';
import { map, concatMap, switchMap, finalize } from 'rxjs/operators';
import { FilterService } from 'primeng/api';
import { Table } from 'primeng/table';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocListEntry } from 'src/app/shared/doc-list-entry';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ProductApiService, StockResult } from 'src/app/services/product-api.service';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-list-manufacturing-status',
  templateUrl: './list-manufacturing-status.component.html',
  styleUrls: ['./list-manufacturing-status.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListManufacturingStatusComponent implements OnInit, OnDestroy, OnChanges {
  @Input() docId: number;

  globalSettinsData: GlobalSettingsData;

  /*
     PRODID - ИД Изделия
     PRODCODE - Изделие
     PARTID - ИД Части
     PARTCODE - Часть 
     STOCK - На складе 
     REQNTY - Требуется 
     GIVEN - Передано 
     mSUM - На сумму 
     DEBT - Долг <
     fromST1 - C основного 
     fromST2 - C импорта 
     fromST3 - C заемного 
  */

  recordsList: any[] = [];

  totalRecords: number = 0;

  selectedRecord: any;

  today: Date;

  loading: boolean = false;

  sumREQNTY: number = 0;
  sumGIVEN: number = 0;
  summSUM: number = 0;
  sumDEBT: number = 0;
  sumFromST1: number = 0;
  sumFromST2: number = 0;
  sumFromST3: number = 0;

  private recordsQuery: Subscription;

  @ViewChild('ptable1') ptable1: Table;

  cf1: any = {};    // to store f[string] filters value

  constructor(
    private restapi: RestApiService,
    private docApi: DocumentApiService,
    private prodApi: ProductApiService,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** ListManufacturingStatusComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      switch (propName) {
        case 'clean':
          this.clearSavedSettings();

        case 'docId':
          this.loadRecentOrdersData();
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** ListManufacturingStatusComponent in ngOnDestroy");

    if (this.recordsQuery) { this.recordsQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log("*** ListManufacturingStatusComponent in ngOnInit");

    this.today = new Date();

    console.log('*** Home in onInit: ' + JSON.stringify(this.today));

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.loadRecentOrdersData();
  }

  loadRecentOrdersData(): void {
    if (this.globalSettinsData) {
      this.loading = true;

      let ms = this.globalSettinsData.getMainStock();
      let is = this.globalSettinsData.getImpStock();
      let as = this.globalSettinsData.getAuxStock();
      let ma = this.globalSettinsData.manDepartmentId;

      this.recordsQuery =
        this.docApi.getDocumentManufacturedStatus(this.docId,ms,is,as,ma,new Date())
          .pipe(
            concatMap(data => {
              this.recordsList = data || [];
              this.totalRecords = this.recordsList.length;

              return from(data);
            }),

            concatMap((data: any) => this.prodApi.getProductStockBefore(data.PARTID, this.globalSettinsData.mainCompanyId, ms, new Date()).pipe(map(stock => {
              data.GIVEN = data.fromST1 + data.fromST2 + data.fromST3
              data.DEBT = data.REQNTY - data.GIVEN;
              data.STOCK = (stock as StockResult[])[0]?.stock ?? 0;
              return data;
            }))),

            concatMap((data: any) => this.prodApi.getProductStockBefore(data.PARTID, this.globalSettinsData.mainCompanyId, is, new Date()).pipe(map(stock => {

              data.STOCK += (stock as StockResult[])[0]?.stock ?? 0;
              return data;
            }))),

            concatMap((data: any) => this.prodApi.getProductStockBefore(data.PARTID, this.globalSettinsData.mainCompanyId, as, new Date()).pipe(map(stock => {

              data.STOCK += (stock as StockResult[])[0]?.stock ?? 0;
              return data;
            }))),

              finalize(() => {
                this.sumREQNTY = this.recordsList.reduce((acc, val) => acc + val.REQNTY, 0);
                this.sumGIVEN = this.recordsList.reduce((acc, val) => acc + val.GIVEN, 0);
                this.summSUM = this.recordsList.reduce((acc, val) => acc + val.mSUM, 0);
                this.sumDEBT = this.recordsList.reduce((acc, val) => acc + val.DEBT, 0); 
                this.sumFromST1 = this.recordsList.reduce((acc, val) => acc + val.fromST1, 0);
                this.sumFromST2 = this.recordsList.reduce((acc, val) => acc + val.fromST2, 0);
                this.sumFromST3 = this.recordsList.reduce((acc, val) => acc + val.fromST3, 0);

                this.loading = false;
              })
            )
          .subscribe();
    }
  }

  onChangeRecentOrdersType(event) {
    console.log('*** ListManufacturingStatusComponent in onChangeRecentOrdersType');
    console.log(event);
    //    this.showProformaDocuments = event.checked;
    this.loadRecentOrdersData();
  }

  onRecentRowSelect(event) {
    //console.log('*** DocumentsComponent onRowSelect: ' + JSON.stringify(event.data))
    //this.messageService.add({ severity: 'info', summary: 'DocumentsComponent Selected', detail: event.data.DOCID });
    //    this.messageService.add({ severity: 'info', summary: 'DocumentsComponent Selected', detail: event.data.DOCTYPEID });

    //this.selectedDocumentId = event.data.DOCID;
    //if (this.selectedDocumentId) {
    //  //this.doLoadDataItems(this.selectedDocumentId);
    //}
  }

  reloadTable() {
    console.log('*** ListManufacturingStatusComponent reloadTable: ');

    this.loadRecentOrdersData();
  }

  onStateSave(state) {
    console.log('*** ListManufacturingStatusComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestoreNew(state) {
    console.log('*** ListManufacturingStatusComponent onStateRestoreNew: ' + JSON.stringify(state));
    if (state.filters) {
      for (let f in state.filters) {
        let fltItem = state.filters[f];
        this.cf1[f] = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;
      }
    }
  }

  clearSavedSettings() {
    console.log('*** ListManufacturingStatusComponent in clearSavedSettings: ');
    try {
      this.ptable1.clearState();
    } catch (e) {
      console.log('*** ListManufacturingStatusComponent in clearSavedSettings: ' + JSON.stringify(e));
    }
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** ListManufacturingStatusComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.recordsList);

      const exportData: any =
        this.recordsList.map(e => ({

          'ИД Изделия': e.PRODID,
          'Изделие': e.PRODCODE,
          'ИД Части': e.PARTID,
          'Часть': e.PARTCODE,
          'На складе': e.STOCK,
          'Требуется': e.REQNTY,
          'Передано': e.GIVEN,
          'На сумму': e.mSUM,
          'Долг': e.DEBT,
          'C основного': e.fromST1,
          'C импорта': e.fromST2,
          'C заемного': e.fromST3,
        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { monitor: worksheet }, SheetNames: ['monitor'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "monitor");
    });
  }
}
